var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab",class:{'tab_selected': _vm.selected, 'tab_disabled': _vm.disabled},on:{"click":function($event){return _vm.$emit('select', _vm.value)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }